module.exports = __webpack_public_path__ + "static/media/school.81c13371.png";